import styled, { css } from 'styled-components'
import {
  color,
  ColorProps,
  fontSize,
  FontSizeProps,
  fontStyle,
  FontStyleProps,
  fontWeight,
  FontWeightProps,
  textAlign,
  TextAlignProps,
  verticalAlign,
  VerticalAlignProps,
  LineHeightProps,
  lineHeight,
} from 'styled-system'
import { getDisplayName } from 'utils'
import { TextTransformProperty } from 'csstype'
import { truncateStyles } from 'components/Truncate'

export interface TextProps
  extends FontWeightProps,
    TextAlignProps,
    VerticalAlignProps,
    FontSizeProps,
    ColorProps,
    LineHeightProps,
    FontStyleProps {
  overflow?: 'ellipsis'
  textTransform?: TextTransformProperty
}

const textCss = css`
  text-transform: ${({ textTransform }: TextProps) => textTransform};
  word-wrap: break-word;
  overflow-wrap: break-word;

  ${({ overflow }: TextProps) =>
    overflow === 'ellipsis' &&
    css`
      ${truncateStyles};
    `};

  ${textAlign}
  ${fontSize}
  ${lineHeight};
  ${color}
  ${fontWeight}
  ${verticalAlign}
  ${fontStyle}
`

export function withText<C extends AnyComponent>(Comp: C) {
  const styledComp = styled(Comp)<TextProps>`
    ${textCss}
  `
  styledComp.displayName = `withText(${getDisplayName(Comp)})`

  return styledComp
}
